import React, {
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react';

import { PayFitColor } from '../../types/module';
import { classNames } from '../../utils/style';
import { applyBgColor } from '../../utils/utils';

import { ComparisonContext } from './ComparisonContext';
import { ButtonV2 } from '../ButtonV2';

export interface ComparisonTransition {
  title: string;
  color?: PayFitColor;
  className?: string;
  children?: ReactNode;
  open?: boolean;
  setOpen?: Dispatch<SetStateAction<boolean>>;
  onClick?: any;
}
export const Transition = ({
  title,
  color = 'white',
  children,
  onClick,
  className,
}: ComparisonTransition) => {
  const refBtn = useRef<HTMLDivElement>(null);
  const background = color && applyBgColor(color);
  const context = useContext<any>(ComparisonContext);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    const paddingComponent = 50;

    setHeight(
      context?.heightGradiantTransition +
        paddingComponent +
        refBtn?.current?.offsetHeight || 0,
    );

    if (context.heightGradiantTransition && context.topGradiantTransition)
      context.setMaxHeight(
        context.heightGradiantTransition +
          refBtn?.current?.offsetHeight +
          context.topGradiantTransition || 'auto',
      );
  }, [
    context,
    context?.heightGradiantTransition,
    context.topGradiantTransition,
    height,
  ]);

  return !context?.open ? (
    <div
      className={classNames(
        'ComparisonTableTransition',
        className,
        'absolute bottom-0 w-full pb-[50px]',
        'flex flex-col',
        'cursor-pointer',
      )}
      style={{
        height,
        top: context?.topGradiantTransition,
      }}
      onClick={() => {
        context?.setOpen(true);
        if (onClick) onClick();
      }}
    >
      <div className={classNames('gradiant flex-1', background)}></div>
      <div
        ref={refBtn}
        className={classNames(
          'flex flex-wrap justify-center pb-[45px] pt-[40px]',
          background,
        )}
      >
        <ButtonV2
          title={title}
          variant="secondary"
          color="default"
          onClick={() => {
            context?.setOpen(true);
            if (onClick) onClick();
          }}
        />
        <div>{children}</div>
      </div>
    </div>
  ) : (
    <span>{children}</span>
  );
};
